import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrollt automatisch naar bovenkant van de pagina bij elke route-wijziging.
 * Mount één keer binnen <BrowserRouter>. Hash-links (#alle-checks) blijven werken
 * — die behandelen we niet (de browser scrollt zelf naar het hash-target).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // laat hash-links hun werk doen
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
